import configCenter from "@gw/odm-db";

export enum OdmCaseEnum {
  Goodwe = "goodwe",
  /** 保碧 */
  Baobi = "baobi",
  /** 上海移动 */
  Shyd = "shyd",
  /** 湖州经济开发区 */
  Hedz = "hedz",
}

/** 根据`configCenter.odmCase`返回合适的值 */
export function odmCaseFilter<T = any>(
  param: Partial<Record<OdmCaseEnum, T>>,
  defaultValue?: T
) {
  return param[configCenter.odmCase as OdmCaseEnum] || defaultValue;
}
